module.exports = __webpack_public_path__ + "static/media/PHOLO.cd19fa2e.mp3";